import { render } from "./TeamingAlert.vue?vue&type=template&id=7a64a445&scoped=true"
import script from "./TeamingAlert.vue?vue&type=script&lang=js"
export * from "./TeamingAlert.vue?vue&type=script&lang=js"

import "./TeamingAlert.vue?vue&type=style&index=0&id=7a64a445&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-7a64a445"

export default script